import { render, staticRenderFns } from "./RawDataComponent.vue?vue&type=template&id=6c953c13&scoped=true"
import script from "./RawDataComponent.vue?vue&type=script&lang=js"
export * from "./RawDataComponent.vue?vue&type=script&lang=js"
import style0 from "./RawDataComponent.vue?vue&type=style&index=0&id=6c953c13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c953c13",
  null
  
)

export default component.exports